import { create } from 'zustand';

export interface NavigationState {
    previousEntryPoint: string | null;
    setPreviousEntryPoint: (path: string) => void;
    clearPreviousEntryPoint: () => void;
}

export const useNavigationStore = create<NavigationState>((set) => ({
    previousEntryPoint: null,
    setPreviousEntryPoint: (path) => set({ previousEntryPoint: path }),
    clearPreviousEntryPoint: () => set({ previousEntryPoint: null }),
})); 